import React from 'react';
import { Col, Input, InputRef, Row } from 'antd';

import Styles from './SearchInput.module.scss';
import { TSearchInput } from './definitions';
import { useHistory } from 'react-router';
import { useSaveRecentSearch } from 'Pages/Home/Hooks/useSaveUserRecentSearch';
import DeleteAccount from '../../../../../../images/delete-search.png';
import Image from 'Pages/Home/Components/Atoms/Image';
import useSaveSearch from 'Pages/Home/Hooks/useSaveSearch';

const SearchInput = React.forwardRef<InputRef, TSearchInput>(
  ({ onChangeText, afterClick, userId, keyword }, ref) => {
    const history = useHistory();
    const [searchText, setSearchText] = React.useState('');

    const { postSaveSearchActivity, postSaveRecentSearch } = useSaveSearch({
      category: 'all_category',
      userId,
    });

    const clearText = () => {
      setSearchText('');
      onChangeText('');
    };

    return (
      <Col>
        <Row align="middle" justify="space-between">
          <Col>
            <Input
              ref={ref}
              placeholder="Type any products here"
              bordered={false}
              onChange={(e) => {
                onChangeText(e.target.value);
                setSearchText(e.target.value);
              }}
              onPressEnter={(e) => {
                if (userId) {
                  postSaveRecentSearch(searchText);
                  postSaveSearchActivity(searchText);
                }
                history.push(
                  `/search?keyword=${searchText.split(' ').join('+')}`,
                );
                if (afterClick) afterClick();
              }}
              className={Styles['search-input']}
              value={keyword}
            />
          </Col>
          <Col className={Styles['delete-container']}>
            {keyword && (
              <Image
                src={DeleteAccount}
                className={Styles['delete-icon']}
                onClick={clearText}
              />
            )}
          </Col>
        </Row>
      </Col>
    );
  },
);

export default SearchInput;
